// extracted by mini-css-extract-plugin
module.exports = {"auth":"AuthPage_auth__aGBPv"};